import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import axios from "axios";
const APIURL = process.env.REACT_APP_API_URL_LOCAL;

export const fetchXtreams = createAsyncThunk(
    "fetchXtreams",
    async ({ headers, params }) => {
        const config = {
            headers: { ...headers },
            params: params
        }
        try {
            const data = await axios.get(`${APIURL}/xtreams/list`, config)
            return data

        } catch (error) {
            return error

        }
    }
);

export const fetchXtreamDetail = createAsyncThunk(
    "fetchXtreamDetail",
    async ({ headers, params }) => {
        const config = {
            headers: { ...headers }
        }
        try {
            const data = await axios.get(`${APIURL}/xtreams/${params.xtreamId}/view`, config)
            return data

        } catch (error) {
            return error

        }
    }
);

export const xtreamSlice = createSlice({
    name: "xtream",
    initialState: {
        xtreams: [],
        total: 0,
        limit: 10,
        page: 1,
        xtreamDetail: {}
    },
    reducers: {
        changeLimit: (state, action) => {
            state.limit = action.payload;
        },
        changePage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchXtreams.fulfilled, (state, action) => {
            if (action?.payload.status == 403) {
                localStorage.removeItem("token");
                localStorage.removeItem("userData");
            }
            if (action?.payload?.data?.success) {
                state.xtreams = action?.payload?.data?.result.xtreams;
                state.total = action?.payload?.data?.result.total;
            }
        });

        builder.addCase(fetchXtreamDetail.fulfilled, (state, action) => {
            if (action?.payload.status == 403) {
                localStorage.removeItem("token");
                localStorage.removeItem("userData");
            }
            console.log(action)
            if (action?.payload?.data?.success) {
                state.xtreamDetail = action?.payload?.data?.result;
            }
        });

    },
});

export const { changeLimit, changePage } = xtreamSlice.actions;
export default xtreamSlice.reducer;

export const xtreamSelector = createSelector(
    (state) => state.xtream.xtreams,
    (state) => state.xtream.total,
    (state) => state.xtream.limit,
    (state) => state.xtream.page,
    (state) => state.xtream.xtreamDetail,
    (xtreams, total, limit, page, xtreamDetail) => ({
        xtreams, total, limit, page, xtreamDetail
    })
);

